<template>
  <div class="view-seller-offers-edit">
    <app-content-title
      title=""
      :link-to="$options.BACK_ROUTE"
      link-text="Вернуться в кабинет продавца"
    ></app-content-title>
    <form
      @submit.prevent="handlerSubmit(false)"
      v-if="!isLoading"
      class="view-seller-offers-edit__wrapper"
    >
      <div class="view-seller-offers-edit__photo-block">
        <seller-offers-form-image
          @upload="(formDataPhoto = $event), (resetFormDataPhoto = false)"
          :reset="resetFormDataPhoto"
          :image="form.photo"
          :formData="formDataPhoto"
        ></seller-offers-form-image>
      </div>

      <div
        class="view-seller-offers-edit__container view-seller-offers-edit__name-block"
      >
        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              isRequired
              size="large"
              title="Название продукта"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>

            <app-title-required-field
              class="view-seller-offers-edit__wrapper-msg"
            ></app-title-required-field>
          </div>

          <div class="view-seller-offers-edit__wrapper-field-group">
            <div class="row">
              <div class="col-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.name"
                    title="Сокращенное название"
                    tooltip="Укажите сокращенное название"
                    placeholder="Например, ДТ ЕВРО СОРТ С"
                  ></app-input-control>
                  <small
                    v-if="$v.form.name.$dirty && $v.form.name.$error"
                    class="app-input-group__invalid"
                  >
                    Укажите сокращенное название
                  </small>
                </div>
              </div>
              <div class="col-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.fullName"
                    title="Полное название"
                    tooltip="Укажите полное название"
                    placeholder="Например, Топливо дизельное ЕВРО, сорта С, экологического класса К5 (ДТ-Л-К5) ГОСТ 32511-2013"
                  ></app-input-control>
                  <small
                    v-if="$v.form.fullName.$dirty && $v.form.fullName.$error"
                    class="app-input-group__invalid"
                  >
                    Укажите полное название
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="view-seller-offers-edit__container view-seller-offers-edit__main-content"
      >
        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              size="large"
              title="Информация о продукте"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>

          <div class="view-seller-offers-edit__wrapper-field-group">
            <div class="row">
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-select-control
                    isRequired
                    v-model="category"
                    :options="categoriesList"
                    label="name"
                    track-by="name"
                    :searchable="true"
                    :loading="false"
                    :hideSelected="false"
                    title="Категория"
                    tooltip="Выберите категорию"
                    :internal-search="true"
                    :preserveSearch="true"
                    :allowEmpty="false"
                    placeholder="Выберите категорию"
                    textTransformInput="lowercase"
                  ></app-select-control>
                  <small
                    v-if="$v.form.category.$dirty && $v.form.category.$error"
                    class="app-input-group__invalid"
                  >
                    Выберите категорию
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-select-control
                    isRequired
                    v-model="warehouse"
                    :options="warehousesList"
                    label="name"
                    track-by="name"
                    :searchable="true"
                    :loading="false"
                    :hideSelected="false"
                    title="Склад"
                    tooltip="Выберите склад"
                    :internal-search="true"
                    :preserveSearch="true"
                    :allowEmpty="false"
                    placeholder="Выберите склад"
                    textTransformOption="capitalize"
                  ></app-select-control>
                  <small
                    v-if="$v.form.warehouse.$dirty && $v.form.warehouse.$error"
                    class="app-input-group__invalid"
                  >
                    Выберите склад
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.volumeLimits[perPieceKey].min"
                    :min="
                      id
                        ? formDataVolumeMin
                        : formDefault.volumeLimits[perPieceKey].min
                    "
                    :max="form.volumeLimits[perPieceKey].max"
                    type="numeric"
                    output-type="Number"
                    placeholder="—"
                    title="Мин. объём заказа"
                    tooltip="Укажите минимальный объем заказа"
                  ></app-input-control>
                  <!-- <small
                    v-if="
                      $v.form.volumeLimits['tn'].min.$dirty &&
                      $v.form.volumeLimits['tn'].min.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Укажите минимальный объем заказа
                  </small> -->
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.volumeLimits[perPieceKey].max"
                    :min="form.volumeLimits[perPieceKey].min"
                    :max="
                      id
                        ? formDataVolumeMax
                        : formDefault.volumeLimits[perPieceKey].max
                    "
                    type="numeric"
                    output-type="Number"
                    placeholder="—"
                    title="Макс. объём заказа"
                    tooltip="Укажите максимальный объем заказа"
                  ></app-input-control>
                  <!-- <small
                    v-if="
                      $v.form.volumeLimits['tn'].max.$dirty &&
                      $v.form.volumeLimits['tn'].max.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Укажите максимальный объем заказа
                  </small> -->
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-select-control
                    isRequired
                    v-model="delivery"
                    :options="$options.DELIVERY_OPTIONS"
                    label="name"
                    track-by="name"
                    :searchable="false"
                    :loading="false"
                    :hideSelected="false"
                    title="Способы доставки"
                    tooltip="Выберите возможные способы доставки"
                    :internal-search="true"
                    :preserveSearch="true"
                    placeholder="Выберите способ доставки"
                    :allowEmpty="true"
                    isMultiple
                  ></app-select-control>
                  <small
                    v-if="
                      $v.form.shippingOptions.$dirty &&
                      $v.form.shippingOptions.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Выберите способ доставки
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-calendar-dropdown
                    placeholder="Укажите дату и время"
                    title="Срок действия публикации"
                    tooltip="Срок действия публикации будет установлен до указанной даты. После истечения строка продукт будет автоматически снят с публикации."
                    v-model="form.unpublishDate.value"
                    @type="form.unpublishDate.type = $event"
                    isPerpetualBtn
                    :type="form.unpublishDate.type"
                    :minDate="new Date()"
                  ></app-calendar-dropdown>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-select-control
                    isRequired
                    v-model="contractor"
                    :options="contractorsList"
                    label="name"
                    track-by="name"
                    :searchable="true"
                    :loading="false"
                    :hideSelected="false"
                    title="Контрагент"
                    tooltip="Выберите контрагента"
                    :internal-search="true"
                    :preserveSearch="true"
                    :allowEmpty="false"
                    placeholder="Выберите контрагента"
                    textTransformOption="capitalize"
                  ></app-select-control>
                  <small
                    v-if="
                      $v.form.contractor.$dirty && $v.form.contractor.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Выберите контрагента
                  </small>
                </div>
              </div>
              <div class="col-12 col-xxs-12">
                <app-checkbox-control
                  label="Безопасная сделка"
                  isTooltipLeft
                  id="isSafeTransaction"
                  v-model="form.isSafeTransactionEnable"
                  tooltip="Безопасная сделка"
                  class="view-seller-offers-edit__ownership"
                  :isDisabled="true"
                ></app-checkbox-control>
              </div>
            </div>
          </div>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              size="large"
              title="Характеристики"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>

          <div class="view-seller-offers-edit__wrapper-field-group">
            <div class="row">
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.density"
                    isRequired
                    @input="setPricePerLiter"
                    type="numeric"
                    :precision="3"
                    output-type="Number"
                    placeholder="—"
                    title="Плотность,  г / см3"
                    :isReadonly="isDensityReadonly"
                  ></app-input-control>
                  <small
                    v-if="!$v.form.density.maxValue"
                    class="app-input-group__invalid"
                  >
                    Укажите значение не больше 99
                  </small>
                  <small
                    v-else-if="$v.form.density.$dirty && $v.form.density.$error"
                    class="app-input-group__invalid"
                  >
                    Укажите плотность
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.shipmentDelay"
                    isRequired
                    :min="1"
                    type="numeric"
                    :precision="0"
                    output-type="Number"
                    placeholder="—"
                    title="Количество дней на выборку"
                    tooltip="Значение устанавливается в календарных днях, обычно 5 календарных дней."
                  ></app-input-control>

                  <small
                    v-if="!$v.form.shipmentDelay.maxValue"
                    class="app-input-group__invalid"
                  >
                    Укажите значение не больше 999
                  </small>

                  <small
                    v-else-if="
                      $v.form.shipmentDelay.$dirty &&
                      $v.form.shipmentDelay.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Укажите кол-во дней на выборку <br />
                    (значение не должно быть меньше, чем кол-во дней на оплату)
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.cfpp"
                    isNumericMinus
                    type="numeric"
                    :precision="0"
                    placeholder="—"
                    title="ПТФ"
                    output-type="Number"
                    tooltip="Предельная температура фильтруемости. Самая высокая температура, при которой данный объем топлива не протекает через стандартизированную фильтрующую установку в течение определенного времени, во время охлаждения в стандартизованных условиях."
                  ></app-input-control>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              isRequired
              size="large"
              title="Цена"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>
          <div class="view-seller-offers-edit__wrapper-field-group">
            <div class="row">
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-select-control
                    isRequired
                    v-model="form.priceType"
                    :options="$options.PRICE_TYPE_OPTIONS"
                    label="name"
                    track-by="value"
                    :searchable="false"
                    :loading="false"
                    :hideSelected="false"
                    title="Тип цены"
                    tooltip="Выберите тип цены"
                    :internal-search="true"
                    :preserveSearch="true"
                    placeholder="Выберите тип цены"
                  ></app-select-control>
                  <small
                    v-if="$v.form.priceType.$dirty && $v.form.priceType.$error"
                    class="app-input-group__invalid"
                  >
                    Выберите тип цены
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.paymentDelay"
                    :min="1"
                    type="numeric"
                    :precision="0"
                    output-type="Number"
                    placeholder="—"
                    title="Количество дней на оплату"
                    tooltip="Значение устанавливается в банковских днях, обычно 1 банковский день."
                  ></app-input-control>
                  <small
                    v-if="!$v.form.paymentDelay.maxValue"
                    class="app-input-group__invalid"
                  >
                    Укажите значение не больше 999
                  </small>
                  <small
                    v-else-if="
                      $v.form.paymentDelay.$dirty && $v.form.paymentDelay.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Введите количество дней на оплату
                  </small>
                </div>
              </div>
              <div class="col-6 col-xxs-12">
                <div
                  class="view-seller-offers-edit__wrapper-field-input"
                  v-if="form.priceType && form.priceType.value === 'perTonne'"
                >
                  <app-input-control
                    v-model="form.pricePerTonne"
                    @input="setPricePerLiter"
                    type="numeric"
                    :precision="2"
                    output-type="Number"
                    placeholder="---"
                    title="Цена за тонну, руб."
                  ></app-input-control>
                  <small
                    v-if="!$v.form.pricePerTonne.maxValue"
                    class="app-input-group__invalid"
                  >
                    Укажите значение не больше 999999
                  </small>
                  <small
                    v-else-if="
                      $v.form.pricePerTonne.$dirty &&
                      $v.form.pricePerTonne.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Укажите цену
                  </small>
                </div>
                <div
                  class="view-seller-offers-edit__wrapper-field-input"
                  v-if="form.priceType && form.priceType.value === 'perPiece'"
                >
                  <app-input-control
                    v-model="form.pricePerPiece"
                    type="numeric"
                    :precision="2"
                    output-type="Number"
                    placeholder="---"
                    title="Цена за штуку, руб."
                  ></app-input-control>
                  <small
                    v-if="!$v.form.pricePerPiece.maxValue"
                    class="app-input-group__invalid"
                  >
                    Укажите значение не больше 999999
                  </small>
                  <small
                    v-else-if="
                      $v.form.pricePerPiece.$dirty &&
                      $v.form.pricePerPiece.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Укажите цену
                  </small>
                </div>
              </div>
              <div
                class="col-6 col-xxs-12"
                v-if="form.priceType && form.priceType.value === 'perTonne'"
              >
                <div class="view-seller-offers-edit__wrapper-field-input">
                  <app-input-control
                    v-model="form.pricePerLiter"
                    tooltip="Цена за литр считается автоматически"
                    :max="999"
                    type="numeric"
                    :precision="2"
                    output-type="Number"
                    placeholder="---"
                    title="Цена за литр, руб."
                    isReadonly
                  ></app-input-control>
                  <small
                    v-if="
                      $v.form.pricePerLiter.$dirty &&
                      $v.form.pricePerLiter.$error
                    "
                    class="app-input-group__invalid"
                  >
                    Для расчета укажите цену за тонну и плотность
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              isRequired
              isTooltip
              tooltip="Загрузите актуальный паспорт качества продукции в формате PDF"
              size="large"
              title="Паспорта качества"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>
          <seller-offers-form-documents
            @upload="
              (formDataPassport = $event), (resetFormDataPassport = false)
            "
            :reset="resetFormDataPassport"
            :passport="form.passport"
            :formData="formDataPassport"
            isSingle
          ></seller-offers-form-documents>
          <div
            class="row"
            v-if="$v.formDataPassport.$dirty && $v.formDataPassport.$error"
          >
            <div class="col-12">
              <small class="app-input-group__invalid">
                Загрузите паспорт качества
              </small>
            </div>
          </div>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              size="large"
              title="Запрашивать вид владения авто?"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>

          <app-checkbox-control
            label="Всегда требовать у покупателя указать вид владения авто"
            isTooltipLeft
            id="isOwnership"
            v-model="form.vehicleOwnershipTypeRequired"
            tooltip="Всегда требовать у покупателя указать вид владения авто"
            class="view-seller-offers-edit__ownership"
          ></app-checkbox-control>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <div class="view-seller-offers-edit__wrapper-title-group">
            <app-title-box
              isRequired
              size="large"
              title="Сервис безопасной сделки"
              class="view-seller-offers-edit__wrapper-title"
            >
            </app-title-box>
          </div>

          <app-checkbox-control
            isRequired
            label='Включить безопасную сделку для этого продукта.<br> Подключая сервис безопасной сделки, вы соглашается <a href="/static/uploads/reg-sdeal.pdf" target="_blank">с условиями и правилами работы</a> с номинальным счетом и сервисом "Безопасная сделка"'
            isTooltipLeft
            id="isSafeTransaction"
            :isDisabled="true"
            v-model="form.isSafeTransaction"
            tooltip='Включить безопасную сделку для этого продукта. Подключая сервис безопасной сделки, вы соглашается с условиями и правилами работы с номинальным счетом и сервисом "Безопасная сделка"'
            class="view-seller-offers-edit__ownership"
          ></app-checkbox-control>
          <div
            class="row"
            v-if="
              $v.form.isSafeTransaction.$dirty &&
              $v.form.isSafeTransaction.$error
            "
          >
            <div class="col-12">
              <small class="app-input-group__invalid">
                Для подключения к сервису безопасной сделки необходимо
                ознакомиться и принять условия и правила работы
              </small>
            </div>
          </div>
        </div>

        <div class="view-seller-offers-edit__wrapper-block">
          <app-title-box
            size="large"
            :title="`Текущий статус: ${currentStatus}`"
            class="view-seller-offers-edit__wrapper-title view-seller-offers-edit__status"
          ></app-title-box>
        </div>

        <div class="view-seller-offers-edit__wrapper-actions">
          <div class="row view-seller-offers-edit__wrapper-row">
            <div class="col-6 col-xxs-12 view-seller-offers-edit__wrapper-col">
              <app-button-control
                isBlock
                size="large"
                type="white"
                class="view-seller-offers-edit__wrapper-actions-btn"
                @click="setPreviewData"
                >Предварительный просмотр</app-button-control
              >
            </div>
            <div
              v-if="id && isPublished"
              class="col-6 col-xxs-12 view-seller-offers-edit__wrapper-col"
            >
              <app-button-control
                isBlock
                size="large"
                type="white"
                :loading="isLoadingPublished"
                class="view-seller-offers-edit__wrapper-actions-btn"
                @click="unpublishOfferConfirm"
                >Снять с публикации</app-button-control
              >
            </div>
            <div
              v-if="id && !isPublished"
              class="col-6 col-xxs-12 view-seller-offers-edit__wrapper-col"
            >
              <app-button-control
                isBlock
                size="large"
                type="white"
                class="view-seller-offers-edit__wrapper-actions-btn"
                @click="publishOfferConfirm"
                :loading="isLoadingPublished"
                >Опубликовать предложение</app-button-control
              >
            </div>
            <div
              v-if="!id"
              class="col-6 col-xxs-12 view-seller-offers-edit__wrapper-col"
            >
              <app-button-control
                isBlock
                size="large"
                type="white"
                nativeType="submit"
                @click.prevent="handlerSubmit(true)"
                :loading="isLoadingMainBtn"
                class="view-seller-offers-edit__wrapper-actions-btn"
              >
                Опубликовать + Создать новое
              </app-button-control>
            </div>
            <div class="col-6 col-xxs-12 view-seller-offers-edit__wrapper-col">
              <app-button-control
                isBlock
                :loading="isLoadingMainBtn"
                isWhiteLoader
                size="large"
                type="secondary"
                nativeType="submit"
                @click.prevent="handlerSubmit(false)"
                class="view-seller-offers-edit__wrapper-actions-btn"
                :isDisabled="!checkedPriceChange"
              >
                {{ submitBtnText }}
              </app-button-control>
            </div>
            <div class="col-12" v-if="!checkedPriceChange">
              <small class="app-input-group__invalid">
                Измените срок действия публикации (Запланированное изменение
                цены не может произойти позже истечения срока публикации )
              </small>
            </div>
            <div class="col-12" v-if="$v.$dirty && $v.$error">
              <small class="app-input-group__invalid">
                Заполните поля формы</small
              >
            </div>
            <div class="col-12" v-if="isError">
              <small class="app-input-group__invalid">
                Упс, Что-то пошло не так
              </small>
            </div>
          </div>
        </div>
      </div>
    </form>

    <seller-offers-add-lot
      v-if="!isLoading && id"
      :offerId="id"
      :lots="lots"
      :priceType="form.priceType.value"
    ></seller-offers-add-lot>

    <seller-offers-price-change
      v-if="!isLoading && id"
      :offerId="id"
      :unpublishDate="form.unpublishDate"
      @checkedPriceChange="checkedPriceChange = $event"
    ></seller-offers-price-change>

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>
<script>
import { required, minValue, maxValue, sameAs } from 'vuelidate/lib/validators';
import { OffersRoutes } from '@/helpers/enums/routes';
import { offersMapper } from '@/store/offers';
import { contractorsMapper } from '@/store/contractors';
import { warehousesMapper } from '@/store/warehouses';
import { DELIVERY_OPTIONS } from '@/helpers/enums/delivery';
import { SELLER_OFFER_STATUS } from '@/helpers/enums/statuses';
import { eventBus } from '@/main';
import { nanoid } from 'nanoid';

export default {
  name: 'ViewSellerOffersEdit',
  inject: ['responsive'],
  validations() {
    const form = {
      name: { required },
      fullName: { required },
      category: { required },
      shipmentDelay: {
        required,
        minValue: minValue(this.form.paymentDelay),
        maxValue: maxValue(999),
      },
      paymentDelay: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(999),
      },
      // volumeLimits: {
      //   min: { required },
      //   max: { required },
      // },
      warehouse: { required },
      contractor: { required },
      density: {
        required,
        minValue: minValue(0.001),
        maxValue: maxValue(99),
      },
      shippingOptions: { required },
      priceType: { required },
    };

    if (this.form.isSafeTransactionEnable) {
      form.isSafeTransaction = {
        // eslint-disable-next-line func-names
        sameAs: sameAs(function () {
          return true;
        }),
      };
    } else {
      form.isSafeTransaction = {};
    }

    if (this.form.priceType?.value === 'perPiece') {
      form.pricePerPiece = {
        required,
        minValue: minValue(0.01),
        maxValue: maxValue(999999),
      };
    } else {
      form.pricePerPiece = {};
    }
    if (this.form.priceType?.value === 'perTonne') {
      form.pricePerTonne = {
        required,
        minValue: minValue(0.01),
        maxValue: maxValue(999999),
      };
      form.pricePerLiter = {
        required,
        minValue: minValue(0.01),
        maxValue: maxValue(999999),
      };
    } else {
      form.pricePerTonne = {};
      form.pricePerLiter = {};
    }
    return {
      formDataPassport: { required },
      form,
    };
  },
  components: {
    AppCalendarDropdown: () => import('@/components/ui/AppCalendarDropdown'),
    AppCheckboxControl: () => import('@/components/ui/AppCheckboxControl'),
    AppContentTitle: () => import('@/components/common/AppContentTitle'),
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
    AppTitleRequiredField: () =>
      import('@/components/common/AppTitleRequiredField'),
    AppInputControl: () => import('@/components/ui/AppInputControl'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSelectControl: () => import('@/components/ui/AppSelectControl'),
    AppLoader: () => import('@/components/ui/AppLoader'),
    SellerOffersFormImage: () =>
      import('@/pages/offers/component/sellerForm/SellerOffersFormImage'),
    SellerOffersFormDocuments: () =>
      import('@/pages/offers/component/sellerForm/SellerOffersFormDocuments'),
    SellerOffersPriceChange: () =>
      import('@/pages/offers/component/SellerOffersPriceChange'),
    SellerOffersAddLot: () =>
      import('@/pages/offers/component/SellerOffersAddLot'),
  },
  data: () => ({
    status: null,
    isError: false,
    formDataPassport: null,
    resetFormDataPassport: false,
    formDataPhoto: null,
    formDataVolumeMin: null,
    formDataVolumeMax: null,
    resetFormDataPhoto: false,
    isPublished: true,
    isDensityReadonly: false,
    response: null,
    isLoading: false,
    isLoadingPublished: false,
    isLoadingMainBtn: false,
    delivery: [],
    category: null,
    warehouse: null,
    contractor: null,
    form: {},
    formDefault: {},
    checkedPriceChange: true,
    alertPublishConfirmEventId: nanoid(),
    alertUnpublishConfirmEventId: nanoid(),
    alertCreateConfirmEventId: nanoid(),
    alertEditConfirmEventId: nanoid(),
    isNewOffer: false,
    lots: [],
  }),
  computed: {
    ...offersMapper.mapGetters(['categoriesList']),
    ...offersMapper.mapState(['sellerPreviewData']),
    ...contractorsMapper.mapGetters(['contractorsList']),
    ...warehousesMapper.mapState(['warehousesList']),

    currentStatus() {
      return this.id && this.status
        ? SELLER_OFFER_STATUS[this.status]
        : 'Создание предложения';
    },
    id() {
      return this.$route.params.id ? +this.$route.params.id : null;
    },
    submitBtnText() {
      return this.id ? 'сохранить изменения' : 'опубликовать предложение';
    },
    perPieceKey() {
      if (this.form.priceType?.value === 'perTonne') {
        return 'tn';
      }
      if (this.form.priceType?.value === 'perLiter') {
        return 'lt';
      }
      return 'pc';
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'offers.preview') {
        vm.$v.$touch();
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'offers.preview') {
      this.RESET_SELLER_PREVIEW_DATA();
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.RESET_SELLER_PREVIEW_DATA();
    next();
  },

  watch: {
    category() {
      this.form.category = this.category?.uuid || null;
    },
    warehouse() {
      this.form.warehouse = this.warehouse || null;
    },
    contractor() {
      this.form.contractor = this.contractor || null;
    },
    delivery() {
      this.form.shippingOptions = this.delivery.map((el) => el.valueForSeller);
    },
    'form.priceType': {
      handler(val) {
        const type = val?.value;
        if (type === 'perPiece') {
          this.form.pricePerTonne = 0;
          this.form.pricePerLiter = 0;
          this.form.density = 1;
          this.isDensityReadonly = true;
        } else if (type === 'perTonne') {
          this.form.pricePerPiece = 0;
          this.isDensityReadonly = false;
        }
      },
    },
  },
  async created() {
    this.alertsEventListener();

    this.$options.BACK_ROUTE = { name: OffersRoutes.index };
    this.$options.DELIVERY_OPTIONS = DELIVERY_OPTIONS;
    this.$options.PRICE_TYPE_OPTIONS = [
      {
        name: 'Цена за тонну',
        value: 'perTonne',
      },
      {
        name: 'Цена за штуку',
        value: 'perPiece',
      },
    ];

    try {
      this.isLoading = true;
      this.form = this.createDefaultForm();
      this.formDefault = this.createDefaultForm();
      await this.getCategories();
      await this.getWarehouses();
      if (this.sellerPreviewData.isPreview) {
        this.setStartData(this.sellerPreviewData.formData);
        this.status = this.sellerPreviewData.status;
        this.isPublished = this.sellerPreviewData.isPublished;
        this.formDataPassport = this.sellerPreviewData.formDataPassport;
        this.formDataPhoto = this.sellerPreviewData.formDataPhoto;
      } else if (this.id) {
        const response = await this.getSellerOffer(this.id);
        this.setStartData(response);
        this.status = response.status;
        this.isPublished = !(
          this.status === 'draft' || this.status === 'rejected'
        );
        this.formDataPassport = response.passport;
        this.formDataPhoto = response.photo;
        this.formDataVolumeMin = response.volumeLimits[this.perPieceKey].min;
        this.formDataVolumeMax = response.volumeLimits[this.perPieceKey].max;
        this.lots = response.lots;
      }
      this.delivery = this.form.shippingOptions.map((el) =>
        DELIVERY_OPTIONS.find((delivery) => delivery.valueForSeller === el)
      );
      this.category = this.getCategory(this.form.category);
      this.warehouse = this.form.warehouse;
      this.contractor = this.form.contractor;
    } catch {
      // -
    } finally {
      this.isLoading = false;
    }

    this.form.isSafeTransactionEnable = true;
    this.form.isSafeTransaction = true;
  },
  methods: {
    ...offersMapper.mapActions([
      'createSellerOffer',
      'getCategories',
      'getSellerOffer',
      'publishSellerOffer',
      'unpublishSellerOffer',
      'loadOfferPassport',
      'loadOfferPhoto',
      'editSellerOffer',
    ]),
    ...offersMapper.mapMutations([
      'SET_SELLER_PREVIEW_DATA',
      'RESET_SELLER_PREVIEW_DATA',
    ]),
    ...warehousesMapper.mapActions(['getWarehouses']),
    /**
     * Автоматический расчет цены за литр
     */
    setPricePerLiter() {
      if (this.form.pricePerTonne > 0 && this.form.density > 0) {
        this.form.pricePerLiter = +(
          (this.form.pricePerTonne * this.form.density) /
          1000
        ).toFixed(2);
      }
    },
    /**
     * Установка первоначальных данных
     * @param {Object} response
     */
    setStartData(response) {
      this.form = {
        name: response.name,
        fullName: response.fullName,
        category: response.category,
        shippingOptions: response.shippingOptions,
        density: response.density,
        pricePerLiter: response.pricePerLiter,
        pricePerTonne: response.pricePerTonne,
        pricePerPiece: response.pricePerPiece,
        priceType: this.$options.PRICE_TYPE_OPTIONS.find(
          (el) => el.value === response.priceType
        ),
        photo: response.photo,
        passport: response.passport,
        warehouse: response.warehouse,
        contractor: response.contractor,
        volumeLimits: response.volumeLimits,
        vehicleOwnershipTypeRequired: response.vehicleOwnershipTypeRequired,
        paymentDelay: response.paymentDelay,
        shipmentDelay: response.shipmentDelay,
        cfpp: response.cfpp,
        unpublishDate: response.unpublishDate,
        isSafeTransaction: response.isSafeTransaction,
        isSafeTransactionEnable: response.isSafeTransactionEnable,
      };
    },
    /**
     * Поиск нужной категории
     * @param {Number} id
     * TODO: вынисти getCategory в хелпер
     */
    getCategory(id) {
      const category = this.categoriesList.find((el) => el.uuid === id);
      if (category) {
        return category;
      }
      return null;
    },
    /**
     * Опубликовать
     */
    async publishOffer() {
      try {
        this.isLoadingPublished = true;
        await this.publishSellerOffer(this.id);
        const response = await this.getSellerOffer(this.id);
        this.status = response.status;
        this.isPublished = !(
          this.status === 'draft' || this.status === 'rejected'
        );
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Статус продукта изменен',
          text: '',
        });
      } catch {
        // -
      } finally {
        this.isLoadingPublished = false;
      }
    },
    /**
     * Alert - Подтверждение сохранения
     */
    editOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'сохранить изменения?',
        eventId: this.alertEditConfirmEventId,
      });
    },
    /**
     * Alert - Подтверждение публикации (создание нового)
     */
    createOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'опубликовать предложение?',
        eventId: this.alertCreateConfirmEventId,
      });
    },
    /**
     * Alert - Подтверждение публикации
     */
    publishOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'опубликовать предложение?',
        eventId: this.alertPublishConfirmEventId,
      });
    },
    /**
     * Alert - Подтверждение снятия с публикации
     */
    unpublishOfferConfirm() {
      this.$modal.show('alert-modal', {
        isConfirm: true,
        text: 'снять с публикации?',
        eventId: this.alertUnpublishConfirmEventId,
      });
    },
    /**
     * Слушатель событий на Alert confirm
     */
    alertsEventListener() {
      eventBus.$on('am-accept', (data) => {
        if (data.eventId === this.alertPublishConfirmEventId) {
          this.publishOffer();
        }

        if (data.eventId === this.alertUnpublishConfirmEventId) {
          this.unpublishOffer();
        }

        if (data.eventId === this.alertEditConfirmEventId) {
          this.edit();
        }

        if (data.eventId === this.alertCreateConfirmEventId) {
          this.create(this.isNewOffer);
        }
      });
    },
    /**
     * Снять с публикации
     */
    async unpublishOffer() {
      try {
        this.isLoadingPublished = true;
        await this.unpublishSellerOffer(this.id);
        const response = await this.getSellerOffer(this.id);
        this.status = response.status;
        this.isPublished = !(
          this.status === 'draft' || this.status === 'rejected'
        );
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Продукт успешно снят с публикации',
          text: '',
        });
      } catch {
        // -
      } finally {
        this.isLoadingPublished = false;
      }
    },
    /**
     * Создание дефолтной формы
     */
    createDefaultForm() {
      return {
        name: '',
        fullName: '',
        category: null, // id
        shippingOptions: [],
        density: 0,
        pricePerLiter: 0,
        pricePerTonne: 0,
        pricePerPiece: 0,
        priceType: null,
        photo: null, // uuid
        passport: null, // uuid
        warehouse: null, // uuid
        contractor: null, // id
        shipmentDelay: 1,
        paymentDelay: 1,
        cfpp: 0,
        volumeLimits: {
          tn: {
            min: 0.1,
            max: 50,
          },
          lt: {
            min: 0.1,
            max: 50,
          },
          pc: {
            min: 1,
            max: 50,
          },
        },
        unpublishDate: {
          type: 'empty',
          value: null,
        },
        isSafeTransaction: false,
        isSafeTransactionEnable: false,
      };
    },
    /**
     * Сброс полей
     */
    resetField() {
      this.form = this.createDefaultForm();
      this.category = null;
      this.resetFormDataPassport = true;
      this.resetFormDataPhoto = true;
      this.warehouse = null;
      this.contractor = null;
      this.delivery = [];
      this.status = null;
    },
    /**
     * Сохранение данных офера для превью
     */
    setPreviewData() {
      this.$v.$touch();
      const formData = { ...this.form };
      this.SET_SELLER_PREVIEW_DATA({
        id: this.id,
        isPreview: true,
        isValid: !this.$v.$invalid,
        isPublished: this.isPublished,
        status: this.status,
        formData,
        formDataPassport: this.formDataPassport,
        formDataPhoto: this.formDataPhoto,
      });
      this.$router.push('/offers/preview');
    },
    /**
     * Отправка формы
     * @param {Object} newOffer
     */
    handlerSubmit(newOffer = false) {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      if (this.id) {
        this.editOfferConfirm();
      } else {
        this.isNewOffer = newOffer;
        this.createOfferConfirm();
      }
    },
    /**
     * Обработка formData
     */
    async processingFormData() {
      const formData = { ...this.form };
      if (this.formDataPassport && !this.formDataPassport.uuid) {
        const responsePassport = await this.loadOfferPassport(
          this.formDataPassport
        );
        formData.passport = responsePassport.uuid;
      } else if (this.formDataPassport && this.formDataPassport.uuid) {
        formData.passport = this.formDataPassport.uuid;
      } else {
        formData.passport = null;
      }

      if (this.formDataPhoto && !this.formDataPhoto.uuid) {
        const responsePhoto = await this.loadOfferPhoto(this.formDataPhoto);
        formData.photo = responsePhoto.uuid;
      } else if (this.formDataPhoto && this.formDataPhoto.uuid) {
        formData.photo = this.formDataPhoto.uuid;
      } else {
        formData.photo = null;
      }
      formData.warehouse = formData.warehouse ? formData.warehouse.uuid : null;
      formData.contractorId = formData.contractor
        ? formData.contractor.id
        : null;

      formData.priceType = formData.priceType.value;

      // if (formData.priceType === 'perPiece') {
      //   const { min } = formData.volumeLimits;
      //   const { max } = formData.volumeLimits;
      //   formData.volumeLimits = {
      //     pc: {
      //       min,
      //       max,
      //     },
      //   };
      // }

      return formData;
    },
    /**
     * Создание товара
     * @param {Object} newOffer
     */
    async create(newOffer) {
      // console.log(newOffer);
      // console.log('processingFormData', await this.processingFormData());
      try {
        this.isError = false;
        this.isLoadingMainBtn = true;
        const formData = await this.processingFormData();
        const response = await this.createSellerOffer(formData);
        await this.publishSellerOffer(response.id);
        this.resetField();
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Предложение добавлено',
          text: '',
        });
        if (!newOffer) {
          this.$router.push('/offers');
        }
      } catch {
        this.isError = true;
      } finally {
        this.isLoadingMainBtn = false;
      }
    },
    /**
     * Редактирование товара
     */
    async edit() {
      try {
        this.isError = false;
        this.isLoadingMainBtn = true;
        const formData = await this.processingFormData();

        await this.editSellerOffer({ id: this.id, formData });
        this.$notify({
          group: 'success',
          type: 'success',
          title: 'Изменения сохранены',
          text: '',
        });
      } catch {
        this.isError = true;
      } finally {
        this.isLoadingMainBtn = false;
      }
    },
  },
};
</script>
<style lang="scss">
.view-seller-offers-edit {
  &__title {
    margin-right: 8px;
    font-size: rem(18);
    font-weight: 300;
    white-space: nowrap;
    border-bottom: 1px dashed currentColor;
  }

  &__status {
    margin-bottom: 20px;
  }

  &__ownership {
    margin-bottom: 20px;
    font-size: rem(13) !important;
  }

  &__title--invalid {
    color: $error;
  }

  &__title-input {
    @include input-reset;

    width: 100%;
    font-size: rem(18);
    font-weight: 300;
    line-height: 24px;
    background: transparent;
    border-bottom: 1px dashed transparent;
  }

  &__name-block {
    grid-area: name;
  }

  &__main-content {
    grid-area: content;
  }

  &__photo-block {
    grid-area: photo;
    min-width: 270px;
    max-width: 270px;
    margin-bottom: 15px;

    @include media-md() {
      min-width: 170px;
      max-width: 176px;
    }

    @include media-xs() {
      width: 100%;
      max-width: 300px;
      margin-top: 30px;
    }
  }

  &__container {
    width: 100%;
  }

  &__wrapper {
    position: relative;
    display: grid;
    grid-template-areas: 'photo name' 'photo content';
    grid-template-columns: 270px 2fr;
    column-gap: 60px;
    padding: 40px;
    background: #fff;
    box-shadow: $box-shadow-card-1;

    @include media-md() {
      grid-template-areas: 'photo name' 'content content';
      grid-template-columns: 176px 2fr;
      column-gap: 30px;
      padding: 30px;
    }

    @include media-xs() {
      grid-template-areas: 'photo photo' 'name name' 'content content';
      padding: 20px 15px;
    }
  }

  &__wrapper-title {
    &-top {
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }

  &__wrapper-title-group {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    @include media-xs() {
      position: static;
      margin-bottom: 20px;

      .app-title-box__title {
        font-size: rem(13) !important;
        line-height: 1.384 !important;
      }
    }
  }

  &__wrapper-msg {
    @include media-xs() {
      position: absolute;
      top: 17px;
      right: 15px;
      font-size: rem(10);
    }
  }

  &__wrapper-block {
    padding-bottom: 20px;
    margin-bottom: 40px;
    border-bottom: 1px solid $color-gray-2;

    @include media-xxs() {
      padding-bottom: 0;
      margin-bottom: 10px;
      border-bottom: 0;
    }
  }

  &__wrapper-helper {
    display: inline-block;
    width: 5px;
    height: 5px;
    margin-right: 8px;
    vertical-align: middle;
    background-color: $color-red;
    border-radius: 50%;
  }

  &__wrapper-link {
    margin: 0 0 20px;

    @include media-xxs() {
      display: flex !important;
      justify-content: center;
      width: 100%;
    }
  }

  &__wrapper-icon {
    width: 26px;
    height: 26px;
    margin: 0 15px 0 0;
  }

  &__wrapper-date-link {
    @include media-xxs() {
      margin-top: 15px;
    }
  }

  &__wrapper-actions {
    @include media-xxs() {
      margin-bottom: -10px;
    }

    &-btn {
      height: 60px !important;
      text-transform: uppercase;
    }

    .app-button-control--white {
      font-weight: bold;
      color: $color-brand-green !important;
    }
  }

  &__wrapper-row {
    margin-bottom: -20px;

    @include media-sm() {
      margin-right: -10px;
      margin-left: -10px;
    }

    @include media-xxs() {
      margin-bottom: -10px;
    }
  }

  &__wrapper-col {
    margin-bottom: 20px;

    @include media-sm() {
      padding-right: 10px;
      padding-left: 10px;
    }

    @include media-xxs() {
      margin-bottom: 10px;
    }
  }

  &__wrapper-field-input {
    margin-bottom: 20px;

    @include media-xxs() {
      margin-bottom: 10px;
    }
  }

  &__upload {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 320px;
    text-align: center;
    cursor: pointer;
    border: 1px dashed $accent;

    @include media-md() {
      height: 235px;
    }

    @include media-xs() {
      height: 195px;
    }

    &-img {
      width: 48px;
      height: 48px;
      margin: 0 0 10px;
      fill: $color-brand-green;

      @include media-md() {
        width: 36px;
        height: 36px;
        margin-bottom: 0;
      }

      @include media-md() {
        width: 25px;
        height: 25px;
      }
    }

    &-text {
      font-size: rem(14);
      line-height: 1.7;
      color: $accent;

      @include media-md() {
        font-size: rem(11);
      }

      @include media-xxs() {
        font-size: rem(9);
      }
    }

    &-helper {
      position: absolute;
      bottom: 20px;
      left: 50%;
      width: 100%;
      padding: 0 20px;
      font-size: rem(11);
      line-height: 1.7;
      opacity: 0.8;
      transform: translateX(-50%);
    }
  }

  &__documents {
    > .row {
      > div {
        margin-bottom: -1px;
      }
    }

    .app-circle-btn {
      margin-top: 20px;
    }
  }
}
</style>
